export default __webpack_public_path__ + "static/media/BuildAnimals Poster.c1ce4733.jpg";